import {AppDispatch} from '../redux/rootReducer';
import {hideLoader, showLoader} from '../redux/action/loaderAction';
import {logoutAction} from '../redux/action/loginAction';
import requestErrorHandler, {ErrorJsonHandlerMap} from './requestErrorHandler';

export const postJsonData = (url: string, body: string, dispatch: AppDispatch, throwError: boolean = false, statusHandler: ErrorJsonHandlerMap = {}) => {
    dispatch(showLoader());

    const request = fetch(window.environment.backend + url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body
    }).then((response) => {

        if (!response.ok) {
            if (!throwError) {
                dispatch(hideLoader());
            }
            throw response;
        }

        dispatch(hideLoader());

        return response.json();
    });

    if (!throwError) {
        return requestErrorHandler(request, 'POST', dispatch, statusHandler);
    }

    return request;
};

export const jsonData = (url: string, method: string, handleError: boolean, dispatch: AppDispatch, baseUrl = window.environment.backend, acceptHeader = 'application/json') => {
    dispatch(showLoader());

    const headers: HeadersInit = {};

    if (acceptHeader) {
        headers.Accept = acceptHeader;
    }

    const request = fetch(baseUrl + url, {
        method: method,
        credentials: 'include',
        headers
    }).then((response) => {
        if (response.status === 401 || response.status === 403) {
            window.sessionStorage.setItem('notLoggedInLocation', window.location.toString());
            dispatch(logoutAction());
        }

        if (!response.ok) {
            if (!handleError) {
                dispatch(hideLoader());
            }
            throw response;
        }

        dispatch(hideLoader());

        return response.json();
    });

    if (handleError) {
        return requestErrorHandler(request, method, dispatch);
    }

    return request;
};

export const getJsonData = (url: string, dispatch: AppDispatch) => {
    return jsonData(url, 'GET', true, dispatch);
};

export const getJsonDataNoError = (url: string, dispatch: AppDispatch) => {
    return jsonData(url, 'GET', false, dispatch);
};

export const deleteJsonData = (url: string, dispatch: AppDispatch) => {
    return jsonData(url, 'DELETE', true, dispatch);
};

export const postFormData = (url: string, data: FormData, dispatch: AppDispatch, throwError: boolean = false) => {
    dispatch(showLoader());
    const request = fetch(window.environment.backend + url, {
        method: 'POST',
        credentials: 'include',
        body: data
    }).then((response) => {

        if (!response.ok) {
            if (!throwError) {
                dispatch(hideLoader());
            }
            throw response;
        }
        dispatch(hideLoader());

        return response.json();
    });
    if (!throwError) {
        return requestErrorHandler(request, 'POST', dispatch);
    }
    return request;
};